/* unplugin-vue-components disabled */import script from "./ScoreDatePicker.vue?vue&type=script&setup=true&lang=js"
export * from "./ScoreDatePicker.vue?vue&type=script&setup=true&lang=js"

import "./ScoreDatePicker.vue?vue&type=style&index=0&id=563b4ce0&lang=less&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/prod-fe.pro/src/fe-pro/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-563b4ce0"]])

export default __exports__